var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Cross2Icon } from '@radix-ui/react-icons';
import { cls_button, cls_button_arrow_down, cls_button_arrow_up, cls_button_close_icon, cls_button_color_negative, cls_button_color_not_action, cls_button_color_primary, cls_button_login_icon, cls_button_logout_icon, cls_button_menu_icon, cls_button_nostyle, cls_button_plus_minus, cls_button_plus_minus_horizontal_line, cls_button_plus_minus_vertical_line, cls_button_small, } from "./button.css";
import { join } from "framework/helpers";
import { HBox } from "framework/structural_components/hbox_vbox";
export var Intent;
(function (Intent) {
    Intent[Intent["Primary"] = 0] = "Primary";
    Intent[Intent["NotAction"] = 1] = "NotAction";
    Intent[Intent["Negative"] = 2] = "Negative";
})(Intent || (Intent = {}));
function getColorClassByIntent(intent) {
    if (intent == Intent.Primary) {
        return cls_button_color_primary;
    }
    if (intent == Intent.NotAction) {
        return cls_button_color_not_action;
    }
    if (intent == Intent.Negative) {
        return cls_button_color_negative;
    }
    return cls_button_color_primary;
}
export var Button = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonSmall = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_small, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonCloseIcon = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_close_icon, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }),
        React.createElement(Cross2Icon, null));
});
export var ButtonLoginIcon = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_login_icon, props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonLogoutIcon = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_logout_icon, props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonMenuIcon = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_menu_icon, props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonPlus = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_plus_minus, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }),
        React.createElement(HBox, { className: cls_button_plus_minus_horizontal_line }),
        React.createElement(HBox, { className: cls_button_plus_minus_vertical_line }));
});
export var ButtonMinus = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_plus_minus, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }),
        React.createElement(HBox, { className: cls_button_plus_minus_horizontal_line }));
});
export var ButtonArrowUp = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_arrow_up, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonArrowDown = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_arrow_down, getColorClassByIntent(props.intent), props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
export var ButtonNoStyle = React.forwardRef(function (props, forwardRef) {
    var className = props.className, passing_props = __rest(props, ["className"]);
    var cls = join(cls_button_nostyle, props.className);
    return React.createElement("button", __assign({ ref: forwardRef }, passing_props, { className: cls }));
});
